<template>
  <button
    type="button"
    class="workoutBoolChoice"
    role="switch"
    :aria-checked="value === true ? 'true' : 'false'"
    :aria-label="ariaLabel"
    :disabled="disabled"
    @click="toggle"
  >
    <span
      class="workoutBoolChoice__thumb"
      :class="{ 'workoutBoolChoice__thumb--true': value === true }"
      aria-hidden="true"
    />
    <span
      class="workoutBoolChoice__label"
      :class="{ 'workoutBoolChoice__label--active': value !== true }"
      aria-hidden="true"
    >
      {{ falseLabel }}
    </span>
    <span
      class="workoutBoolChoice__label"
      :class="{ 'workoutBoolChoice__label--active': value === true }"
      aria-hidden="true"
    >
      {{ trueLabel }}
    </span>
  </button>
</template>

<script>
export default {
  name: 'WorkoutBoolChoice',
  props: {
    value: { type: Boolean, required: true },
    falseLabel: { type: String, default: '否' },
    trueLabel: { type: String, default: '是' },
    ariaLabel: { type: String, default: '二选一' },
    disabled: { type: Boolean, default: false },
  },
  methods: {
    toggle() {
      if (this.disabled) {
        return
      }
      this.$emit('input', this.value !== true)
    },
  },
}
</script>

<style scoped>
/**
 * 二选一 toggle：外观是左右两格，交互是「点任意处翻转 + 滑块过渡」。
 */
.workoutBoolChoice {
  position: relative;
  display: grid;
  grid-template-columns: 1fr 1fr;
  width: 100%;
  min-width: 120px;
  margin: 0;
  padding: 3px;
  border: 1px solid var(--link-line-strong, #e5dfd6);
  border-radius: var(--link-radius-sm, 8px);
  background: var(--link-field-bg, #f3f0ea);
  box-sizing: border-box;
  overflow: hidden;
  cursor: pointer;
  font-family: var(--link-font-family);
  text-align: center;
  -webkit-tap-highlight-color: transparent;
  transition: border-color 0.15s ease;
}

.workoutBoolChoice:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}

.workoutBoolChoice:hover {
  border-color: var(--link-ink-faint, #d6d3d1);
}

.workoutBoolChoice:focus-visible {
  outline: 2px solid var(--link-accent);
  outline-offset: 1px;
}

.workoutBoolChoice:active {
  transform: scale(0.99);
}

.workoutBoolChoice__thumb {
  position: absolute;
  z-index: 0;
  top: 3px;
  bottom: 3px;
  left: 3px;
  width: calc((100% - 6px) / 2);
  border-radius: calc(var(--link-radius-sm, 8px) - 2px);
  background: var(--link-accent-bg, #f0f7ff);
  border: 1px solid var(--link-accent-border, #cce5ff);
  box-shadow: none;
  transform: translateX(0);
  transition: transform 0.3s cubic-bezier(0.34, 1.25, 0.64, 1);
  pointer-events: none;
}

.workoutBoolChoice__thumb--true {
  transform: translateX(100%);
}

.workoutBoolChoice__label {
  position: relative;
  z-index: 1;
  min-width: 0;
  padding: 6px 8px;
  color: var(--link-ink-secondary, #4a4541);
  font-size: var(--link-text-xs, 12px);
  font-weight: var(--link-font-medium, 500);
  line-height: 1.2;
  user-select: none;
  pointer-events: none;
  transition: color 0.2s ease;
}

.workoutBoolChoice__label--active {
  color: var(--link-accent);
  font-weight: var(--link-font-semibold, 600);
}

@media (prefers-reduced-motion: reduce) {
  .workoutBoolChoice__thumb {
    transition: none;
  }

  .workoutBoolChoice:active {
    transform: none;
  }
}
</style>
